import {
    Button,
    DialogTitle,
    Dialog,
    DialogContent,
    DialogActions,
    DialogContentText,
    Typography,
    Stack,
    Box,
    CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import './RoleSelectionDialog.css';
import RoleCard from './RoleCard';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { auth } from 'apis';
import { switchFunction } from 'apis/controllers/auth';
import { useSnackbar } from 'notistack';
import { useQueryClient } from 'react-query';
import { handleRoleSelection, selectRole, setCreds, setRoles } from 'store/roleReducer';
import { storeMenu } from 'store/menuReducer';
import decodeToken from 'util/decode-token';
import { login } from 'store/authReducer';

const RoleSelectionDialog = (props) => {
    const { n1 = null, ...rest } = props;
    const { t } = useTranslation();
    const theme = useTheme();
    const [disabledButtons, setDisabledButtons] = useState(false);
    const { openRoleSelection, roles, creds, token, selectedRole } = useSelector((state) => state.role);
    const { redirectTo } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const queryClient = useQueryClient();



    const onClose = () => {
        dispatch(handleRoleSelection(false));
        dispatch(setCreds({ creds: null }))
        setDisabledButtons(false);
    };


    const handleSelectRole = async (item) => {
        if (!disabledButtons) {
            setDisabledButtons(true);
            if (creds) {
                let res;
                if (creds?.isPaLogin) {
                    res = await auth.paLogin({
                        token: creds?.token,
                        urpfId: item?.value
                    })
                }

                else {
                    res = await auth.login({
                        username: creds?.username ?? creds?.email,
                        password: creds?.password,
                        selectedUrpfId: item?.value
                    });
                }
                const decodedToken = decodeToken(token);

                dispatch(storeMenu(res?.menu));
                dispatch(
                    login({
                        token: res?.token,
                        refreshToken: res?.refreshToken,
                        user: res?.user,
                        seasonId: res?.season,
                        original_name: decodedToken?.original_name
                    })
                );
                dispatch(selectRole({ selectedRole: item?.value }))
                dispatch(setCreds({ creds: null }));
                enqueueSnackbar(t('LoginSuccess'), {
                    variant: 'success'
                });
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const navUrl = urlParams.get('navUrl');
                if (navUrl) navigate(navUrl);
                else {
                    navigate('/home');
                }
                onClose();
            } else {
                const res = await switchFunction({ urpfId: item?.value });
                const decodedToken = decodeToken(token);
                if (res?.menu) await dispatch(storeMenu(res?.menu));
                dispatch(
                    login({
                        token: res?.token,
                        refreshToken: res?.refreshToken,
                        user: res?.user,
                        seasonId: res?.season,
                        original_name: decodedToken?.original_name
                    })
                );
                dispatch(selectRole({ selectedRole: item?.value }))
                await dispatch(setCreds({ creds: null }));
                navigate('/home');
                enqueueSnackbar(t('RoleSwitchSuccessful'), {
                    variant: 'success'
                });
                await queryClient.invalidateQueries('me');
                if (window?.location?.pathname === '/home' && redirectTo === res?.redirectTo) navigate(0);
                onClose();
            }
        }
    };

    return (
        <Dialog open={openRoleSelection ?? false} onClose={onClose} {...rest} maxWidth="lg" fullWidth>
            <DialogTitle>
                <Typography variant="h3" sx={{ flexGrow: 1 }}>
                    ΕΠΙΛΟΓΗ ΡΟΛΟΥ
                </Typography>
            </DialogTitle>
            {disabledButtons ? (
                <DialogContent sx={{ display: 'flex', minHeight: 300, justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                </DialogContent>
            ) : (
                <DialogContent sx={{ bgcolor: '#fefefe' }}>
                    <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={4} sx={{ mb: 0 }}>
                        <DialogContentText>
                            <Box
                                sx={{
                                    p: 1,
                                    whiteSpace: 'pre-wrap',
                                    overflowWrap: 'break-word'
                                }}
                            >
                                Παρακαλώ επιλέξτε τον ρόλο με τον οποίο θέλετε να συνδεθείτε!
                            </Box>
                        </DialogContentText>
                    </Stack>
                    <div className="role-card-grid">
                        {roles?.map((item, index) => (
                            <RoleCard key={index} data={item} isSelected={item?.selected || selectedRole === item?.value} handleSelectRole={() => handleSelectRole(item)} />
                        ))}
                    </div>
                </DialogContent>
            )}
        </Dialog>
    );
};

export default RoleSelectionDialog;
